import React, { useState } from 'react'
import YouTube from 'react-youtube'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import iconLuna from '../../../assets/images/icon-luna.svg'
import { textChange } from '../../../constants/activity-constants'

import './techNight.scss'

const TechNight = () => {
  const [videoId] = useState('BKyhg4fBg9M')
  const isMobile = useMediaQuery()
  const [player, setPlayer] = useState(null)
  const [showLayer, setShowLayer] = useState(true)

  const onReady = event => {
    setPlayer(event.target)
  }

  const onPlayVideo = () => {
    player.playVideo()
    try {
      window.dataLayer.push({
        event: 'ga_event',
        category: 'ui :: landing :: ver demo',
        action: 'play video',
        label: 'conoce sus detalles',
        value: '',
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onPauseVideo = () => {
    player.pauseVideo()
    try {
      window.dataLayer.push({
        event: 'ga_event',
        category: 'ui :: landing :: ver demo',
        action: 'pause video',
        label: 'conoce sus detalles',
        value: '',
      })
    } catch (error) {
      console.log(error)
    }
  }

  const opts = {
    height: '400',
    width: '700',
    playerVars: {
      autoplay: 1,
    },
  }

  const optsMobile = {
    height: '200',
    width: '320',
    playerVars: {
      autoplay: 1,
    },
  }

  return (
    <div className="f-container-techNight">
      <div id="verdemo" className="f-container-techNight__ancla" />
      {isMobile && (
        <>
          <div className="f-container-techNight__content__right__top">
            <h2>
              Tecnología <br />
              <span>en la noche</span>
            </h2>
            <img src={iconLuna} alt="icono en las noches" />
          </div>
          <div className="f-container-techNight__content__right__bot">
            <p>{textChange.text_13}</p>
          </div>
        </>
      )}
      <div
        className={`f-container-techNight__content ${
          showLayer ? '' : 'showVideo'
        }`}
      >
        {showLayer ? (
          <>
            <button
              className="f-container-techNight__content__play"
              onClick={() => {
                setShowLayer(false)
              }}
            />
            {!isMobile && (
              <div className="f-container-techNight__content__right">
                <div className="f-container-techNight__content__right__top">
                  <h2>
                    Tecnología <br />
                    <span>en la noche</span>
                  </h2>
                  <img src={iconLuna} alt="icono en las noches" />
                </div>
                <div className="f-container-techNight__content__right__bot">
                  <p>{textChange.text_13}</p>
                  <button
                    className="f-container-techNight__content__right__bot__button"
                    onClick={() => {
                      setShowLayer(false)
                    }}
                  >
                    <p>Conoce sus detalles</p> <span>Ver Demo </span>
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <YouTube
              videoId={videoId ? videoId : ''}
              onReady={onReady}
              opts={isMobile ? optsMobile : opts}
              onPlay={onPlayVideo}
              onPause={onPauseVideo}
            />
            <button
              className="showVideoButton"
              onClick={() => {
                setShowLayer(true)
                onPauseVideo()
              }}
            >
              <p>Cerrar video</p>
            </button>
          </>
        )}
      </div>
      {isMobile && showLayer && (
        <button
          className="f-container-techNight__content__right__bot__button"
          onClick={() => {
            setShowLayer(false)
          }}
        >
          <p>Conoce sus detalles</p> <span>Ver Demo </span>
        </button>
      )}
    </div>
  )
}

export default TechNight
